import _ from 'lodash'
import RedMetricsModel from './red-metrics-model'
import RedMetricNewView from './red-metrics-new'
import GrayMetricsPath from '../gray-metrics/gray-metrics-path'
import AncestorStep from '../common/ancestor-step'

const RedMetricsStep2 = _.assign({}, GrayMetricsPath.steps[1], {
	titleCode:'report.redMetricsReport.title',
	view: RedMetricNewView
})

const RedMetricsPath = {
	icon: 'warn',
	key: 'report.redMetricsReport.title',
	steps: [AncestorStep, RedMetricsStep2],
	model: RedMetricsModel
}

export default RedMetricsPath

RedMetricsPath.__filename__ = 'reports/wizard/red-metrics/red-metrics-path.js'
